import {useAppDispatch, useAppSelector} from "../../reducers/hooks"
import React, {MouseEvent, useEffect, useMemo, useState} from "react"
import {BoxElement, deleteElement, getAllElementBox} from "../../reducers/Box/BoxReducer"
import {ColumnDef, ColumnFiltersState} from "@tanstack/react-table"
import Stack from "@mui/material/Stack"
import {Typography} from "@mui/material"
import Tooltip from "@mui/material/Tooltip"
import IconButton from "@mui/material/IconButton"
import {Edit, Trash} from "iconsax-react"
import Grid from "@mui/material/Grid"
import BasicTable from "../../components/tables/BasicTable"
import ElementModalGeneric from "../../sections/modals/exampleElementModal/ElementModalGeneric"
import AlertExampleElementDelete from "../../sections/modals/exampleElementModal/AlertExampleElementDelete"
import TablePagination from "@mui/material/TablePagination"
import {openSnackbar, SnackbarState} from "reducers/snackbar/snackbarReducer"
import {FormattedMessage, useIntl} from "react-intl"
import {BoxFormElement} from "../../sections/forms/Box/BoxFormElement"
import ViewBoxModal from "../../components/tables/modal-historical/ViewBoxModal"
import CustomLoader from "../../components/CustomLoader";


export default function Box() {
    const dispatch = useAppDispatch()
    const intl = useIntl()

    const [open, setOpen] = useState<boolean>(false)
    const [selectedElement, setSelectedElement] = useState<BoxElement | null>(null)
    const [selectedDeleteElement, setSelectedDeleteElement] = useState<BoxElement | null>(null)
    const [deleteAlertOpen, setDeleteAlertOpen] = useState<boolean>(false)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [filters, setFilters] = useState<ColumnFiltersState | null>([])
    const [viewModalOpen, setViewModalOpen] = useState<boolean>(false)
    const [selectedBox, setSelecteBox] = useState<string | undefined>(undefined)

    const {elements, currentPage, totalRows, loading, sort} = useAppSelector((state) => state.boxElement)

    const columns = useMemo<ColumnDef<BoxElement>[]>(() => {
        return [

            {
                header: intl.formatMessage({id: "Name"}),
                accessorKey: 'name',
            },
            {
                header: intl.formatMessage({id: "MaxCapacity"}),
                accessorKey: 'maxCapacity',
                enableColumnFilter: false
            },
            {
                header: intl.formatMessage({id: "DogintoBox"}),
                accessorKey: 'dogIntoBox',
                enableColumnFilter: false

            },
            {
                header: intl.formatMessage({id: "Maintenance"}),
                accessorKey: 'isMaintenance',
                enableColumnFilter: false,

                cell: ({row}) => {
                    return (
                        <Stack direction="row" alignItems="center" justifyContent="center">
                            <Typography>
                                {row.original.isMaintenance !== undefined
                                    ? (row.original.isMaintenance ? "in Maintenance" : "Not in Maintenance")
                                    : "Value Undefined"}
                            </Typography>
                        </Stack>
                    )
                },
            },
            {
                header: intl.formatMessage({id: "isAvailable"}),
                accessorKey: 'isAvailable',
                enableColumnFilter: false,
                cell: ({row}) => {
                    return (
                        <Typography>
                            {row.original.isAvailable !== undefined
                                ? (row.original.isAvailable ? "Available" : "Not Available")
                                : "Value Undefined"}
                        </Typography>
                    )
                },
            },
            {
                header: intl.formatMessage({id: "Shed"}),
                accessorKey: 'shedId.name',
                enableColumnFilter: true,

            },

            {
                header: () => <FormattedMessage id="Actions" defaultMessage="Actions"/>,
                accessorKey: 'Actions',
                enableColumnFilter: false,
                cell: ({row}) => {
                    const box = row.original
                    return (
                        <Stack direction="row" spacing={1}>
                            <Tooltip title="Edit">
                                <IconButton
                                    color="primary"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setSelectedElement(box)
                                        setOpen(true)
                                    }}
                                >
                                    <Edit/>
                                </IconButton>
                            </Tooltip>
                            {/*<Tooltip title={<FormattedMessage id="View" defaultMessage="View" />}>
                                <IconButton
                                    color="default"
                                    onClick={(e) => {

                                        e.stopPropagation()
                                        setSelecteBox(row.original._id || undefined)
                                        setViewModalOpen(true)
                                    }}
                                >
                                    <Eye variant="Bold"/>
                                </IconButton>
                            </Tooltip>*/}
                            <Tooltip title="Delete">
                                <IconButton
                                    color="error"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setSelectedDeleteElement(box)
                                        setDeleteAlertOpen(true)
                                    }}
                                >
                                    <Trash/>
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    )
                }
            }
        ]
    }, [intl])


    useEffect(() => {
        if (!loading) {
            dispatch(getAllElementBox({
                pageableDto: {
                    page: page,
                    size: rowsPerPage,
                    sort: ['lastUpdated', 'asc']
                },
                filters: filters
            }))
        }
    }, [page, rowsPerPage, JSON.stringify(filters)])

    const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => setPage(newPage)
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }


    const handleModalOpen = (isOpen: boolean) => {
        setOpen(isOpen)
        if (!isOpen) setSelectedElement(null)
    }

    const columnFiltersState = (values: ColumnFiltersState) => {
        setPage(0)
        setFilters(values)
    }

    const onDeleteSuccess = () => {
        dispatch(getAllElementBox({pageableDto: {page: currentPage, size: rowsPerPage, sort}, filters: filters}))
        openSnackbar(
            {
                open: true,
                message: 'Element deleted successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            } as SnackbarState
        )
    }

    const handleDelete = (id: string) => dispatch(deleteElement({id, callback: onDeleteSuccess}))

    const refreshData = () => {
        dispatch(getAllElementBox({
            pageableDto: {
                page: page,
                size: rowsPerPage,
                sort: ['dateCreated', 'desc']
            },
            filters: filters
        }))
        openSnackbar({
            open: true,
            message: intl.formatMessage({id: 'Box Added complete'}),
            variant: 'alert',
            alert: {
                color: 'success'
            }
        } as SnackbarState)
    }

    return (
        <>
            <CustomLoader open={loading} message="Caricamento in corso..."/>

            <Grid container>
                <Grid item xs={12}>
                    <BasicTable
                        columns={columns}
                        data={elements}
                        title="Box"
                        striped
                        modalToggler={() => handleModalOpen(!open)}
                        onFilterChange={columnFiltersState}
                        manualFiltering={true}
                    />
                    <TablePagination
                        component="div"
                        count={totalRows}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                    <ViewBoxModal
                        open={viewModalOpen}
                        onClose={() => setViewModalOpen(false)}
                        boxData={selectedBox}
                    />
                    <ElementModalGeneric
                        open={open}
                        setOpen={handleModalOpen}
                        element={selectedElement}
                        FormComponent={BoxFormElement}
                        onSuccess={refreshData}
                        pageableData={{
                            page,
                            rowsPerPage,
                            filters
                        }}
                    />
                    {selectedDeleteElement && (
                        <AlertExampleElementDelete
                            id={selectedDeleteElement._id}
                            title={selectedDeleteElement.name}
                            open={deleteAlertOpen}
                            handleClose={() => setDeleteAlertOpen(false)}
                            onDelete={(id) => handleDelete(id)}
                        />
                    )}
                </Grid>
            </Grid>
        </>
    )
}